import React, { useEffect, useState } from 'react'
import RecommendedJobCard from '../../../components/Cards/RecommendedJobCard'
import Pdf from '../../employer/employerComponents/Pdf'
import { FaShare, FaUserTie } from 'react-icons/fa'
import { PiBagFill } from 'react-icons/pi'
import { IoCalendarOutline, IoLanguage, IoLocationOutline } from 'react-icons/io5'
import { HiLightBulb } from 'react-icons/hi2'
import { RiVideoFill } from 'react-icons/ri'
import VideoPlayer from '../../../components/VideoJS/VideoPlayer'
import { MdAddToPhotos } from 'react-icons/md'
import { GrLocation } from 'react-icons/gr'
import { HiOutlineBriefcase } from 'react-icons/hi2'
import { useContext } from 'react'
import SuperAdminContext from '../../../hooks/SuperAdminContext'
import Select from 'react-dropdown-select'
import axiosInstance from '../../../services/api/axiosInstance'
import toast from 'react-hot-toast'
import { encryptData } from 'Security/Crypto/Crypto'


const ProfessionalDetailedView = () => {
    const duplicateArrayContent = [1, 2, 3];
    const recommendedPlaceholderArray = [1, 2, 3];
    const {
        initialGlow, experience,
        education, skills,
        video, language,
        additionalInfo,
        professionalSelectedCardData,
        professionalAbout,
        professionalPreferences,
        professionalPdf, selectedcard,
        handleProfessionalupdateNotes,
        professionalkeepNotes, setProfessionalKeepNotes,
        handleProfessionalGetCompany,
        makeRecommendationLoading,
        setMakeRecommendationLoading,
        recCompanyList, recommendedProfiles,
        getAdminDashboard, professionalId,
        deletingCardId, setDeletingCardId,
        professionalApplyFilterCount,
        professionalApplyFilterObject, professionalExpertNotes,
        professionalMakeRecommendation, setprofessionalMakeRecommendation,
        professionalClearNotes, professionalSendNotes,
        setprofessionalClearNotes, setprofessionalSendNotes,
        professionalPagination, handleAdminProfessionalMeilisearch
    } = useContext(SuperAdminContext);

    const [convertCompantList, setConvertCompantList] = useState([]);
    const [convertRoleList, setConvertRoleList] = useState([]);
    const [selectedCompanyName, setSelectedCompanyName] = useState([]);
    const [selectedJobRole, setSelectedJobRole] = useState([]);
    const [recomFeedback, setRecomFeedback] = useState("");
    const recomBtnDisable = recommendedProfiles.length;
    const professional_personal_details = [
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375Z" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
            value: professionalSelectedCardData.email_id
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_1078_4557)">
                    <path d="M16.4999 0H13.4999C13.301 0 13.1102 0.0790176 12.9696 0.21967C12.8289 0.360322 12.7499 0.551088 12.7499 0.75C12.7499 0.948912 12.8289 1.13968 12.9696 1.28033C13.1102 1.42098 13.301 1.5 13.4999 1.5H15.4394L13.6394 3.3C12.8185 2.68011 11.8324 2.31731 10.8056 2.25737C9.77867 2.19744 8.75706 2.44307 7.86965 2.96325C7.20082 2.57677 6.45484 2.3429 5.68508 2.27836C4.91532 2.21382 4.1408 2.32021 3.41696 2.58992C2.69311 2.85962 2.03782 3.28598 1.49796 3.83848C0.958114 4.39099 0.54705 5.05598 0.294182 5.78588C0.0413135 6.51578 -0.0471074 7.29255 0.0352453 8.06061C0.117598 8.82867 0.368688 9.56903 0.770552 10.2287C1.17242 10.8884 1.71512 11.4512 2.35983 11.8767C3.00454 12.3021 3.73533 12.5799 4.4999 12.69V14.25H2.9999C2.80099 14.25 2.61023 14.329 2.46957 14.4697C2.32892 14.6103 2.2499 14.8011 2.2499 15C2.2499 15.1989 2.32892 15.3897 2.46957 15.5303C2.61023 15.671 2.80099 15.75 2.9999 15.75H4.4999V17.25C4.4999 17.4489 4.57892 17.6397 4.71957 17.7803C4.86023 17.921 5.05099 18 5.2499 18C5.44882 18 5.63958 17.921 5.78023 17.7803C5.92089 17.6397 5.9999 17.4489 5.9999 17.25V15.75H7.4999C7.69882 15.75 7.88958 15.671 8.03023 15.5303C8.17089 15.3897 8.2499 15.1989 8.2499 15C8.2499 14.8011 8.17089 14.6103 8.03023 14.4697C7.88958 14.329 7.69882 14.25 7.4999 14.25H5.9999V12.6952C6.6592 12.597 7.29346 12.3729 7.86815 12.0353C8.91306 12.6464 10.1373 12.8769 11.333 12.6876C12.5286 12.4982 13.6217 11.9008 14.4267 10.9966C15.2317 10.0926 15.6987 8.93762 15.7485 7.72813C15.7983 6.51864 15.4278 5.32922 14.6999 4.362L16.4999 2.562V4.5C16.4999 4.69891 16.5789 4.88968 16.7196 5.03033C16.8602 5.17098 17.051 5.25 17.2499 5.25C17.4488 5.25 17.6396 5.17098 17.7802 5.03033C17.9209 4.88968 17.9999 4.69891 17.9999 4.5V1.5C17.9999 1.10218 17.8419 0.720644 17.5606 0.43934C17.2793 0.158035 16.8977 0 16.4999 0V0ZM1.4999 7.5C1.49635 6.89089 1.64209 6.29018 1.92438 5.75042C2.20668 5.21066 2.61692 4.74828 3.11924 4.40374C3.62155 4.05919 4.20063 3.84297 4.80584 3.77398C5.41104 3.70499 6.02393 3.78534 6.5909 4.008C5.72761 4.96622 5.24986 6.21025 5.24986 7.5C5.24986 8.78975 5.72761 10.0338 6.5909 10.992C6.02393 11.2147 5.41104 11.295 4.80584 11.226C4.20063 11.157 3.62155 10.9408 3.11924 10.5963C2.61692 10.2517 2.20668 9.78934 1.92438 9.24958C1.64209 8.70982 1.49635 8.10911 1.4999 7.5ZM10.4999 11.25C9.75822 11.25 9.0332 11.0301 8.41651 10.618C7.79983 10.206 7.31918 9.62029 7.03535 8.93506C6.75153 8.24984 6.67726 7.49584 6.82196 6.76841C6.96665 6.04098 7.32381 5.3728 7.84825 4.84835C8.3727 4.3239 9.04089 3.96675 9.76831 3.82206C10.4957 3.67736 11.2497 3.75162 11.935 4.03545C12.6202 4.31928 13.2059 4.79993 13.6179 5.41661C14.03 6.0333 14.2499 6.75832 14.2499 7.5C14.2487 8.4942 13.8532 9.44733 13.1502 10.1503C12.4472 10.8533 11.4941 11.2488 10.4999 11.25Z" fill="#595959" />
                </g>
                <defs>
                    <clipPath id="clip0_1078_4557">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>,
            value: professionalSelectedCardData?.gender
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M14.2526 11.875H12.6693V13.4583H14.2526M14.2526 8.70833H12.6693V10.2917H14.2526M15.8359 15.0417H9.5026V13.4583H11.0859V11.875H9.5026V10.2917H11.0859V8.70833H9.5026V7.125H15.8359M7.91927 5.54167H6.33594V3.95833H7.91927M7.91927 8.70833H6.33594V7.125H7.91927M7.91927 11.875H6.33594V10.2917H7.91927M7.91927 15.0417H6.33594V13.4583H7.91927M4.7526 5.54167H3.16927V3.95833H4.7526M4.7526 8.70833H3.16927V7.125H4.7526M4.7526 11.875H3.16927V10.2917H4.7526M4.7526 15.0417H3.16927V13.4583H4.7526M9.5026 5.54167V2.375H1.58594V16.625H17.4193V5.54167H9.5026Z" fill="#595959" />
            </svg>,
            value: professionalSelectedCardData?.sector
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" />
            </svg>,
            value: '+' + professionalSelectedCardData?.country_code + " " + professionalSelectedCardData?.contact_number
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_1078_4560)">
                    <path d="M9 4.5C8.40666 4.5 7.82664 4.67595 7.33329 5.00559C6.83994 5.33524 6.45543 5.80377 6.22836 6.35195C6.0013 6.90013 5.94189 7.50333 6.05765 8.08527C6.1734 8.66721 6.45912 9.20176 6.87868 9.62132C7.29824 10.0409 7.83279 10.3266 8.41473 10.4424C8.99667 10.5581 9.59987 10.4987 10.1481 10.2716C10.6962 10.0446 11.1648 9.66006 11.4944 9.16671C11.8241 8.67336 12 8.09334 12 7.5C12 6.70435 11.6839 5.94129 11.1213 5.37868C10.5587 4.81607 9.79565 4.5 9 4.5ZM9 9C8.70333 9 8.41332 8.91203 8.16665 8.7472C7.91997 8.58238 7.72771 8.34811 7.61418 8.07403C7.50065 7.79994 7.47095 7.49834 7.52882 7.20736C7.5867 6.91639 7.72956 6.64912 7.93934 6.43934C8.14912 6.22956 8.41639 6.0867 8.70737 6.02882C8.99834 5.97094 9.29994 6.00065 9.57403 6.11418C9.84812 6.22771 10.0824 6.41997 10.2472 6.66665C10.412 6.91332 10.5 7.20333 10.5 7.5C10.5 7.89783 10.342 8.27936 10.0607 8.56066C9.77936 8.84196 9.39783 9 9 9Z" fill="#595959" />
                    <path d="M8.99975 18.0002C8.3682 18.0035 7.74508 17.8553 7.18255 17.5683C6.62001 17.2812 6.13444 16.8635 5.7665 16.3502C2.90825 12.4075 1.4585 9.44347 1.4585 7.53997C1.4585 5.5399 2.25302 3.62176 3.66728 2.2075C5.08154 0.793241 6.99968 -0.00128174 8.99975 -0.00128174C10.9998 -0.00128174 12.918 0.793241 14.3322 2.2075C15.7465 3.62176 16.541 5.5399 16.541 7.53997C16.541 9.44347 15.0912 12.4075 12.233 16.3502C11.8651 16.8635 11.3795 17.2812 10.8169 17.5683C10.2544 17.8553 9.63129 18.0035 8.99975 18.0002ZM8.99975 1.63597C7.43406 1.63775 5.93301 2.26051 4.8259 3.36762C3.71879 4.47473 3.09603 5.97578 3.09425 7.54147C3.09425 9.04897 4.514 11.8367 7.091 15.391C7.30977 15.6923 7.59677 15.9376 7.92853 16.1067C8.26029 16.2758 8.62737 16.3639 8.99975 16.3639C9.37212 16.3639 9.7392 16.2758 10.071 16.1067C10.4027 15.9376 10.6897 15.6923 10.9085 15.391C13.4855 11.8367 14.9052 9.04897 14.9052 7.54147C14.9035 5.97578 14.2807 4.47473 13.1736 3.36762C12.0665 2.26051 10.5654 1.63775 8.99975 1.63597Z" fill="#595959" />
                </g>
                <defs>
                    <clipPath id="clip0_1078_4560">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>,
            value: professionalSelectedCardData?.willing_to_relocate ? professionalSelectedCardData?.willing_to_relocate === "Yes" ? professionalSelectedCardData?.willing_to_relocate + ", I am willing to relocate" : professionalSelectedCardData?.willing_to_relocate + ", I am not willing to relocate" : null
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M14.9999 5.24988H2.99999C2.17157 5.24988 1.5 5.92144 1.5 6.74986V14.2498C1.5 15.0782 2.17157 15.7498 2.99999 15.7498H14.9999C15.8283 15.7498 16.4999 15.0782 16.4999 14.2498V6.74986C16.4999 5.92144 15.8283 5.24988 14.9999 5.24988Z" stroke="#595959" stroke-width="1.66678" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.9999 15.7496V3.74974C11.9999 3.35192 11.8419 2.97039 11.5606 2.68909C11.2793 2.40779 10.8978 2.24976 10.5 2.24976H7.49999C7.10217 2.24976 6.72064 2.40779 6.43934 2.68909C6.15803 2.97039 6 3.35192 6 3.74974V15.7496" stroke="#595959" stroke-width="1.66678" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
            value: professionalSelectedCardData?.job_type
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_1078_4543)">
                    <path d="M9 4.5C8.40666 4.5 7.82664 4.67595 7.33329 5.00559C6.83994 5.33524 6.45543 5.80377 6.22836 6.35195C6.0013 6.90013 5.94189 7.50333 6.05765 8.08527C6.1734 8.66721 6.45912 9.20176 6.87868 9.62132C7.29824 10.0409 7.83279 10.3266 8.41473 10.4424C8.99667 10.5581 9.59987 10.4987 10.1481 10.2716C10.6962 10.0446 11.1648 9.66006 11.4944 9.16671C11.8241 8.67336 12 8.09334 12 7.5C12 6.70435 11.6839 5.94129 11.1213 5.37868C10.5587 4.81607 9.79565 4.5 9 4.5ZM9 9C8.70333 9 8.41332 8.91203 8.16665 8.7472C7.91997 8.58238 7.72771 8.34811 7.61418 8.07403C7.50065 7.79994 7.47095 7.49834 7.52882 7.20736C7.5867 6.91639 7.72956 6.64912 7.93934 6.43934C8.14912 6.22956 8.41639 6.0867 8.70737 6.02882C8.99834 5.97094 9.29994 6.00065 9.57403 6.11418C9.84812 6.22771 10.0824 6.41997 10.2472 6.66665C10.412 6.91332 10.5 7.20333 10.5 7.5C10.5 7.89783 10.342 8.27936 10.0607 8.56066C9.77936 8.84196 9.39783 9 9 9Z" fill="#595959" />
                    <path d="M8.99975 18.0002C8.3682 18.0035 7.74508 17.8553 7.18255 17.5683C6.62001 17.2812 6.13444 16.8635 5.7665 16.3502C2.90825 12.4075 1.4585 9.44347 1.4585 7.53997C1.4585 5.5399 2.25302 3.62176 3.66728 2.2075C5.08154 0.793241 6.99968 -0.00128174 8.99975 -0.00128174C10.9998 -0.00128174 12.918 0.793241 14.3322 2.2075C15.7465 3.62176 16.541 5.5399 16.541 7.53997C16.541 9.44347 15.0912 12.4075 12.233 16.3502C11.8651 16.8635 11.3795 17.2812 10.8169 17.5683C10.2544 17.8553 9.63129 18.0035 8.99975 18.0002ZM8.99975 1.63597C7.43406 1.63775 5.93301 2.26051 4.8259 3.36762C3.71879 4.47473 3.09603 5.97578 3.09425 7.54147C3.09425 9.04897 4.514 11.8367 7.091 15.391C7.30977 15.6923 7.59677 15.9376 7.92853 16.1067C8.26029 16.2758 8.62737 16.3639 8.99975 16.3639C9.37212 16.3639 9.7392 16.2758 10.071 16.1067C10.4027 15.9376 10.6897 15.6923 10.9085 15.391C13.4855 11.8367 14.9052 9.04897 14.9052 7.54147C14.9035 5.97578 14.2807 4.47473 13.1736 3.36762C12.0665 2.26051 10.5654 1.63775 8.99975 1.63597Z" fill="#595959" />
                </g>
                <defs>
                    <clipPath id="clip0_1078_4543">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>,
            value: professionalSelectedCardData?.city + "," + professionalSelectedCardData?.country
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_1078_4563)">
                    <path d="M5.25 10.5C5.25 10.6989 5.17098 10.8897 5.03033 11.0303C4.88968 11.171 4.69891 11.25 4.5 11.25H3.75C3.55109 11.25 3.36032 11.171 3.21967 11.0303C3.07902 10.8897 3 10.6989 3 10.5C3 10.3011 3.07902 10.1103 3.21967 9.96967C3.36032 9.82902 3.55109 9.75 3.75 9.75H4.5C4.69891 9.75 4.88968 9.82902 5.03033 9.96967C5.17098 10.1103 5.25 10.3011 5.25 10.5ZM8.25 9.75H7.5C7.30109 9.75 7.11032 9.82902 6.96967 9.96967C6.82902 10.1103 6.75 10.3011 6.75 10.5C6.75 10.6989 6.82902 10.8897 6.96967 11.0303C7.11032 11.171 7.30109 11.25 7.5 11.25H8.25C8.44891 11.25 8.63968 11.171 8.78033 11.0303C8.92098 10.8897 9 10.6989 9 10.5C9 10.3011 8.92098 10.1103 8.78033 9.96967C8.63968 9.82902 8.44891 9.75 8.25 9.75ZM4.5 12.75H3.75C3.55109 12.75 3.36032 12.829 3.21967 12.9697C3.07902 13.1103 3 13.3011 3 13.5C3 13.6989 3.07902 13.8897 3.21967 14.0303C3.36032 14.171 3.55109 14.25 3.75 14.25H4.5C4.69891 14.25 4.88968 14.171 5.03033 14.0303C5.17098 13.8897 5.25 13.6989 5.25 13.5C5.25 13.3011 5.17098 13.1103 5.03033 12.9697C4.88968 12.829 4.69891 12.75 4.5 12.75ZM8.25 12.75H7.5C7.30109 12.75 7.11032 12.829 6.96967 12.9697C6.82902 13.1103 6.75 13.3011 6.75 13.5C6.75 13.6989 6.82902 13.8897 6.96967 14.0303C7.11032 14.171 7.30109 14.25 7.5 14.25H8.25C8.44891 14.25 8.63968 14.171 8.78033 14.0303C8.92098 13.8897 9 13.6989 9 13.5C9 13.3011 8.92098 13.1103 8.78033 12.9697C8.63968 12.829 8.44891 12.75 8.25 12.75ZM4.5 3.75H3.75C3.55109 3.75 3.36032 3.82902 3.21967 3.96967C3.07902 4.11032 3 4.30109 3 4.5C3 4.69891 3.07902 4.88968 3.21967 5.03033C3.36032 5.17098 3.55109 5.25 3.75 5.25H4.5C4.69891 5.25 4.88968 5.17098 5.03033 5.03033C5.17098 4.88968 5.25 4.69891 5.25 4.5C5.25 4.30109 5.17098 4.11032 5.03033 3.96967C4.88968 3.82902 4.69891 3.75 4.5 3.75ZM8.25 3.75H7.5C7.30109 3.75 7.11032 3.82902 6.96967 3.96967C6.82902 4.11032 6.75 4.30109 6.75 4.5C6.75 4.69891 6.82902 4.88968 6.96967 5.03033C7.11032 5.17098 7.30109 5.25 7.5 5.25H8.25C8.44891 5.25 8.63968 5.17098 8.78033 5.03033C8.92098 4.88968 9 4.69891 9 4.5C9 4.30109 8.92098 4.11032 8.78033 3.96967C8.63968 3.82902 8.44891 3.75 8.25 3.75ZM4.5 6.75H3.75C3.55109 6.75 3.36032 6.82902 3.21967 6.96967C3.07902 7.11032 3 7.30109 3 7.5C3 7.69891 3.07902 7.88968 3.21967 8.03033C3.36032 8.17098 3.55109 8.25 3.75 8.25H4.5C4.69891 8.25 4.88968 8.17098 5.03033 8.03033C5.17098 7.88968 5.25 7.69891 5.25 7.5C5.25 7.30109 5.17098 7.11032 5.03033 6.96967C4.88968 6.82902 4.69891 6.75 4.5 6.75ZM8.25 6.75H7.5C7.30109 6.75 7.11032 6.82902 6.96967 6.96967C6.82902 7.11032 6.75 7.30109 6.75 7.5C6.75 7.69891 6.82902 7.88968 6.96967 8.03033C7.11032 8.17098 7.30109 8.25 7.5 8.25H8.25C8.44891 8.25 8.63968 8.17098 8.78033 8.03033C8.92098 7.88968 9 7.69891 9 7.5C9 7.30109 8.92098 7.11032 8.78033 6.96967C8.63968 6.82902 8.44891 6.75 8.25 6.75ZM18 7.5V14.25C17.9988 15.2442 17.6033 16.1973 16.9003 16.9003C16.1973 17.6033 15.2442 17.9988 14.25 18H3.75C2.7558 17.9988 1.80267 17.6033 1.09966 16.9003C0.396661 16.1973 0.00119089 15.2442 0 14.25L0 3.75C0.00119089 2.7558 0.396661 1.80267 1.09966 1.09966C1.80267 0.396661 2.7558 0.00119089 3.75 0L8.25 0C9.2442 0.00119089 10.1973 0.396661 10.9003 1.09966C11.6033 1.80267 11.9988 2.7558 12 3.75H14.25C15.2442 3.75119 16.1973 4.14666 16.9003 4.84966C17.6033 5.55267 17.9988 6.5058 18 7.5ZM3.75 16.5H10.5V3.75C10.5 3.15326 10.2629 2.58097 9.84099 2.15901C9.41903 1.73705 8.84674 1.5 8.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5ZM16.5 7.5C16.5 6.90326 16.2629 6.33097 15.841 5.90901C15.419 5.48705 14.8467 5.25 14.25 5.25H12V16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V7.5ZM14.25 9.75C14.1017 9.75 13.9567 9.79399 13.8333 9.8764C13.71 9.95881 13.6139 10.0759 13.5571 10.213C13.5003 10.35 13.4855 10.5008 13.5144 10.6463C13.5434 10.7918 13.6148 10.9254 13.7197 11.0303C13.8246 11.1352 13.9582 11.2066 14.1037 11.2356C14.2492 11.2645 14.4 11.2497 14.537 11.1929C14.6741 11.1361 14.7912 11.04 14.8736 10.9167C14.956 10.7933 15 10.6483 15 10.5C15 10.3011 14.921 10.1103 14.7803 9.96967C14.6397 9.82902 14.4489 9.75 14.25 9.75ZM14.25 12.75C14.1017 12.75 13.9567 12.794 13.8333 12.8764C13.71 12.9588 13.6139 13.0759 13.5571 13.213C13.5003 13.35 13.4855 13.5008 13.5144 13.6463C13.5434 13.7918 13.6148 13.9254 13.7197 14.0303C13.8246 14.1352 13.9582 14.2066 14.1037 14.2356C14.2492 14.2645 14.4 14.2497 14.537 14.1929C14.6741 14.1361 14.7912 14.04 14.8736 13.9167C14.956 13.7933 15 13.6483 15 13.5C15 13.3011 14.921 13.1103 14.7803 12.9697C14.6397 12.829 14.4489 12.75 14.25 12.75ZM14.25 6.75C14.1017 6.75 13.9567 6.79399 13.8333 6.8764C13.71 6.95881 13.6139 7.07594 13.5571 7.21299C13.5003 7.35003 13.4855 7.50083 13.5144 7.64632C13.5434 7.7918 13.6148 7.92544 13.7197 8.03033C13.8246 8.13522 13.9582 8.20665 14.1037 8.23559C14.2492 8.26453 14.4 8.24968 14.537 8.19291C14.6741 8.13614 14.7912 8.04002 14.8736 7.91668C14.956 7.79334 15 7.64834 15 7.5C15 7.30109 14.921 7.11032 14.7803 6.96967C14.6397 6.82902 14.4489 6.75 14.25 6.75Z" fill="#595959" />
                </g>
                <defs>
                    <clipPath id="clip0_1078_4563">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>,
            value: professionalSelectedCardData?.industry_sector
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                <path d="M12.859 7.176L4.74253 12.7089C2.81497 14.0208 3.70459 17.0319 6.035 17.0886L8.75102 17.1547C9.50547 17.1731 10.2077 17.5458 10.6457 18.1604L12.2224 20.3729C13.5752 22.2712 16.561 21.3172 16.5741 18.9891L16.6085 9.16625C16.6153 7.23388 14.4557 6.08755 12.859 7.176Z" stroke="#595959" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
            value: professionalSelectedCardData?.location_preference
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path d="M6.0006 17H12.0006C15.0156 17 15.5556 15.7925 15.7131 14.3225L16.2756 8.3225C16.4781 6.4925 15.9531 5 12.7506 5H5.2506C2.0481 5 1.5231 6.4925 1.7256 8.3225L2.2881 14.3225C2.4456 15.7925 2.9856 17 6.0006 17Z" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6 5V4.4C6 3.0725 6 2 8.4 2H9.6C12 2 12 3.0725 12 4.4V5" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 10.25V11C10.5 11.0075 10.5 11.0075 10.5 11.015C10.5 11.8325 10.4925 12.5 9 12.5C7.515 12.5 7.5 11.84 7.5 11.0225V10.25C7.5 9.5 7.5 9.5 8.25 9.5H9.75C10.5 9.5 10.5 9.5 10.5 10.25Z" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.2375 8.75C14.505 10.01 12.525 10.76 10.5 11.015" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.96289 8.95215C3.65039 10.1071 5.55539 10.8046 7.49789 11.0221" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
            value: professionalSelectedCardData?.years_of_experience ? professionalSelectedCardData?.years_of_experience + ` ${professionalSelectedCardData?.years_of_experience > 1 ? "years" : "year"} of experience` : null
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_1078_4566)">
                    <path d="M14.25 3H13.425C13.2509 2.15356 12.7904 1.39301 12.1209 0.846539C11.4515 0.300068 10.6142 0.00109089 9.75 0L8.25 0C7.38585 0.00109089 6.54849 0.300068 5.87906 0.846539C5.20964 1.39301 4.74907 2.15356 4.575 3H3.75C2.7558 3.00119 1.80267 3.39666 1.09966 4.09966C0.396661 4.80267 0.00119089 5.7558 0 6.75L0 14.25C0.00119089 15.2442 0.396661 16.1973 1.09966 16.9003C1.80267 17.6033 2.7558 17.9988 3.75 18H14.25C15.2442 17.9988 16.1973 17.6033 16.9003 16.9003C17.6033 16.1973 17.9988 15.2442 18 14.25V6.75C17.9988 5.7558 17.6033 4.80267 16.9003 4.09966C16.1973 3.39666 15.2442 3.00119 14.25 3ZM8.25 1.5H9.75C10.2137 1.50192 10.6655 1.64706 11.0435 1.91557C11.4216 2.18407 11.7074 2.56282 11.862 3H6.138C6.29256 2.56282 6.57842 2.18407 6.95648 1.91557C7.33453 1.64706 7.7863 1.50192 8.25 1.5ZM3.75 4.5H14.25C14.8467 4.5 15.419 4.73705 15.841 5.15901C16.2629 5.58097 16.5 6.15326 16.5 6.75V9H1.5V6.75C1.5 6.15326 1.73705 5.58097 2.15901 5.15901C2.58097 4.73705 3.15326 4.5 3.75 4.5ZM14.25 16.5H3.75C3.15326 16.5 2.58097 16.2629 2.15901 15.841C1.73705 15.419 1.5 14.8467 1.5 14.25V10.5H8.25V11.25C8.25 11.4489 8.32902 11.6397 8.46967 11.7803C8.61032 11.921 8.80109 12 9 12C9.19891 12 9.38968 11.921 9.53033 11.7803C9.67098 11.6397 9.75 11.4489 9.75 11.25V10.5H16.5V14.25C16.5 14.8467 16.2629 15.419 15.841 15.841C15.419 16.2629 14.8467 16.5 14.25 16.5Z" fill="#595959" />
                </g>
                <defs>
                    <clipPath id="clip0_1078_4566">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>,
            value: professionalSelectedCardData?.functional_specification
        },
        {
            icons: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path d="M12.75 7.25C12.75 10.1525 10.23 12.5 7.125 12.5L6.42751 13.34L6.015 13.835C5.6625 14.255 4.9875 14.165 4.755 13.6625L3.75 11.45C2.385 10.49 1.5 8.9675 1.5 7.25C1.5 4.3475 4.02 2 7.125 2C9.39 2 11.3475 3.25251 12.225 5.05251C12.5625 5.72001 12.75 6.4625 12.75 7.25Z" stroke="#595959" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.5002 10.145C16.5002 11.8625 15.6152 13.385 14.2502 14.345L13.2452 16.5575C13.0127 17.06 12.3377 17.1575 11.9852 16.73L10.8752 15.395C9.06023 15.395 7.44023 14.5925 6.42773 13.34L7.12523 12.5C10.2302 12.5 12.7502 10.1525 12.7502 7.24998C12.7502 6.46248 12.5627 5.71999 12.2252 5.05249C14.6777 5.61499 16.5002 7.68497 16.5002 10.145Z" stroke="#595959" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.25 7.25H9" stroke="#595959" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
            value: professionalSelectedCardData?.mode_of_communication
        }
    ]

    useEffect(() => {
        if (recCompanyList.length > 0) {
            var cvrt = recCompanyList.map((v, i) => {
                return { label: v.company_name, value: v.employer_id }
            })

            setConvertCompantList(cvrt)
        } else {
            setConvertCompantList([])
        }
    }, [recCompanyList])

    useEffect(() => {
        handleSelectedCompany(selectedCompanyName)
    }, [selectedCompanyName])

    const handleCopytext = (share_link) => {
        navigator.clipboard.writeText(share_link);
        toast.success("Link copied");
    };

    const handleExpertNotes = (e) => {
        var limitingCharacters = e.target.value.slice(0, 250);
        setProfessionalKeepNotes(limitingCharacters)
    }

    const handleSetRecommendationFeedback = (e) => {
        var limitingRecommendationCharacters = e.target.value.slice(0, 250);
        setRecomFeedback(limitingRecommendationCharacters)
    }

    const handleDateConvert = (value) => {
        var Months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        var splitDate = value.split("-")   // 2024-01
        var l = [splitDate[0]]

        var monthConverted = Months[parseInt(splitDate[1]) - 1]

        l.unshift(monthConverted)

        return l.join(" ")
    }

    const handleSelectedCompany = async () => {
        if (selectedCompanyName.length > 0) {
            setMakeRecommendationLoading(true);
            try {
                var obj = {
                    employer_id: selectedCompanyName[0].value,
                    company_name: selectedCompanyName[0].label
                }


                const res = await axiosInstance.post("/get_job_list", obj);
                if (res.data.error_code === 0) {
                    var roleList = res.data.data.map((v) => {
                        return { label: v.job_title, value: v.id }
                    })
                    setConvertRoleList(roleList)
                } else {
                    setConvertRoleList([])
                    setSelectedJobRole([])
                }
                setMakeRecommendationLoading(false);
            } catch (err) {
                console.log(err);
            }
        }
    }

    const handleDeleteRecommended = async (id) => {
        setDeletingCardId(id)
        try {
            var obj = {
                job_id: id,
                professional_id: professionalId,
                role_id: 3
            }

            const res = await axiosInstance.post("/delete_recommendation", obj)
            if (res.data.error_code === 0) {
                if (professionalApplyFilterCount === 0) {
                    getAdminDashboard("makeRecomrecall");
                } else {
                    handleAdminProfessionalMeilisearch(professionalApplyFilterObject, "makeRecomrecall")
                }
            }

        } catch (err) {
            console.log(err)
        }
    }

    const handleMakeRecomBtn = async () => {
        if (selectedCompanyName.length > 0 && selectedJobRole.length > 0 && recomFeedback !== "") {
            setprofessionalMakeRecommendation(true);
            try {
                var obj = {
                    job_id: selectedJobRole[0].value,
                    professional_id: professionalSelectedCardData.professional_id,
                    description: recomFeedback,
                    flag: "professional",
                    employer_id: ""
                }


                const res = await axiosInstance.post("/make_recommendation", obj);

                if (res.data.error_code === 0) {
                    if (professionalApplyFilterCount === 0) {
                        getAdminDashboard("makeRecomrecall");
                    } else {
                        handleAdminProfessionalMeilisearch(professionalApplyFilterObject, "makeRecomrecall")
                    }
                    setSelectedCompanyName([]);
                    setSelectedJobRole([]);
                } else {
                    setprofessionalMakeRecommendation(false);
                }
            } catch (err) {
                console.log(err)
            }
        }
        else {
            toast.error("please fill in all the fields")
        }
    }

    return (
        <div className='col h-100 overflow-scroll'>
            {initialGlow || selectedcard || professionalPagination ? (
                <div className="card h-100 border-0 rounded-4">
                    <div className="card-body h-100 overflow-scroll p-lg-4 px-lg-2 d-flex flex-wrap p-0 p-lg-3 ">
                        <div className="col-12">
                            <div className="container-fluid">
                                <div className="row border-bottom border-secondary border-1 py-4">
                                    <div className="col-2 text-center">
                                        <img
                                            src={""}
                                            alt="..."
                                            width={100}
                                            height={100}
                                            className="pe-none placeholder rounded-circle"
                                        />
                                        <div className="mt-2">
                                            <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 border-end border-dark placeholder w-100 py-3 rounded-1 me-2"></h1>
                                            <p className="employer-card-candidate-role mb-0 d-inline-block ps-3 placeholder w-100 py-2 rounded-1"></p>
                                        </div>
                                    </div>

                                    <div className="col-10">
                                        <div className="row">
                                            <div className="col-12 pt-4 row">
                                                {
                                                    Array.from({ length: 12 }).map((__, i) => (
                                                        <div className="col-3">
                                                            <p className="employer-card-candidate-role placeholder py-3 w-100 rounded-1"></p>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className="col-12">
                                                <button type="button" className="btn col-4 me-4 py-1 placeholder"></button>

                                                <button type="button" className="btn col-4 py-1 placeholder"></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-12 border-bottom border-secondary border-1 py-4">

                                    <div className="row w-100">
                                        {
                                            initialGlow || selectedcard || professionalPagination ?
                                                recommendedPlaceholderArray.map((v, i) => {
                                                    return <div className="col-12 col-sm-6 col-xl-4 py-2" key={i}>
                                                        <div className="d-flex flex-wrap border rounded-2 w-100 p-3 pe-0">
                                                            <div className="col-3 placeholder rounded-circle pe-none">
                                                                <img
                                                                    src={""}
                                                                    width={48}
                                                                    height={48}
                                                                    className="opacity-0 d-block"
                                                                    alt="..."
                                                                />
                                                            </div>
                                                            <div className="col-9">
                                                                <div className="container-fluid">
                                                                    <p className='mb-0 pb-1 superAdmin-recommended-card-heading placeholder rounded-2 w-100 py-3 mb-1'></p>
                                                                    <p className="mb-0 superAdmin-recommended-card-sub-content mb-1">
                                                                        <span className="pe-2 placeholder rounded-2"><HiOutlineBriefcase /></span>
                                                                        <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                                                    </p>
                                                                    <p className="mb-0 superAdmin-recommended-card-sub-content">
                                                                        <span className="pe-2 placeholder rounded-2"><GrLocation /></span>
                                                                        <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                                :
                                                null
                                        }
                                    </div>

                                    <div className="card border-0 ">
                                        <div className="card-body ">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center">
                                                    <FaUserTie className="me-3 fs-4 placeholder rounded-2 p-3" />
                                                    <span className="placeholder px-3 w-100 py-1 rounded-1"></span>
                                                </label>

                                            </div>
                                            <div className="ms-5 mt-3 profile-descriptions">
                                                <p className={'text-break placeholder rounded-2 w-100 py-5'}></p>
                                            </div>
                                        </div>
                                    </div>

                                    {duplicateArrayContent.map((val) => {
                                        return <div className="ms-5" key={val}>
                                            <div className="d-flex justify-content-between mt-3">
                                                <label className=" d-inline-block w-75 employer-card-Content-short-heading">
                                                    <span className='placeholder rounded-2 w-50 py-3'>{val}</span>
                                                </label>
                                            </div>

                                            <label className="profile-descriptions mt-1">
                                                <span className='placeholder p-2 rounded-1'></span> &nbsp;-&nbsp;<span className='placeholder px-5 rounded-1'>&nbsp; </span>
                                            </label>

                                            <p className={"mt-1 text-break employer-card-Content placeholder rounded-2 py-5 w-100"}>
                                            </p>
                                            <hr />
                                        </div>
                                    })
                                    }


                                    <div className="card border-0">
                                        <div className="card-body ">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center">
                                                    <FaUserTie className="me-3 fs-4 placeholder rounded-2 p-3" />
                                                    <span className="placeholder px-3 w-100 py-1 rounded-1"></span>
                                                </label>

                                            </div>
                                            <div className="ms-5 mt-3 profile-descriptions">
                                                <p className={'text-break placeholder rounded-2 w-100 py-5'}></p>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="col-12 border-bottom border-secondary border-1 py-4">
                                    <div className="card border-0 ">
                                        <div className="card-body ">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center">
                                                    <FaUserTie className="me-3 fs-4 placeholder rounded-2 p-3" />
                                                    <span className="placeholder px-3 w-100 py-1 rounded-1"></span>
                                                </label>

                                            </div>
                                            <div className="ms-5 mt-3 profile-descriptions">
                                                <p className={'text-break placeholder rounded-2 w-100 py-5'}></p>
                                            </div>
                                        </div>
                                    </div>

                                    {duplicateArrayContent.map((val) => {
                                        return <div className="ms-5" key={val}>
                                            <div className="d-flex justify-content-between mt-3">
                                                <label className=" d-inline-block w-75 employer-card-Content-short-heading">
                                                    <span className='placeholder rounded-2 w-50 py-3'>{val}</span>
                                                </label>
                                            </div>

                                            <label className="profile-descriptions mt-1">
                                                <span className='placeholder p-2 rounded-1'></span> &nbsp;-&nbsp;<span className='placeholder px-5 rounded-1'>&nbsp; </span>
                                            </label>

                                            <p className={"mt-1 text-break employer-card-Content placeholder rounded-2 py-5 w-100"}>
                                            </p>
                                            <hr />
                                        </div>
                                    })
                                    }

                                    <div className="card border-0">
                                        <div className="card-body ">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center">
                                                    <FaUserTie className="me-3 fs-4 placeholder rounded-2 p-3" />
                                                    <span className="placeholder px-3 w-100 py-1 rounded-1"></span>
                                                </label>

                                            </div>
                                            <div className="ms-5 mt-3 profile-descriptions">
                                                <p className={'text-break placeholder rounded-2 w-100 py-5'}></p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                professionalSelectedCardData.professional_id !== undefined ?
                    <div className="card h-100 border-0 rounded-4">
                        <div className="card-body h-100 overflow-scroll">
                            <div className="container-fluid pb-5">
                                <div className="row border-bottom border-secondary border-1 py-4">
                                    <div className="col-12 col-sm-3 col-xl-2 text-center">
                                        <img
                                            src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${professionalSelectedCardData.profile_image}`}
                                            alt=""
                                            width={100}
                                            height={100}
                                            className="rounded-circle"
                                        />

                                        <h1 className="employer-card-candidate-name mb-0 d-inline-block w-100 text-center mt-3">
                                            {professionalSelectedCardData.first_name}{" "}
                                            {professionalSelectedCardData.last_name}
                                        </h1>

                                        <p className="employer-card-candidate-role mb-0 text-break">
                                            {
                                                professionalSelectedCardData.experience.length > 0 ?
                                                    professionalSelectedCardData.experience[0].job_title !== undefined ?
                                                        professionalSelectedCardData.experience[0].job_title
                                                        :
                                                        null
                                                    :
                                                    null
                                            }
                                        </p>
                                    </div>

                                    <div className="col-12 col-sm-9 col-xl-10 pt-4 pt-sm-0 ">
                                        <div className="container p-0">
                                            <div className="d-flex flex-wrap align-items-start h-100">
                                                {
                                                    professional_personal_details?.map((v, i) => (
                                                        <div className="col-12 col-md-6 col-lg-4 mt-2">
                                                            <p className="d-flex flex-wrap">
                                                                <span className='col-1'>{v?.icons}</span>
                                                                <span className='text-break col-11 px-3'>
                                                                    {v?.value || "null"}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    ))
                                                }

                                                <div className="col-12 pt-3 row">
                                                    <div className="col-12 col-sm-4">
                                                        <button type={"button"}
                                                            className={`btn w-100 btn-transparent border btn-brand-color candidate-right-side-btn ${recomBtnDisable === 5 ? "pe-none" : null}`}
                                                            data-bs-toggle={"modal"}
                                                            data-bs-target="#professionalMakeRec"
                                                            onClick={() => {
                                                                setprofessionalMakeRecommendation(false);
                                                                setConvertRoleList([]);
                                                                handleProfessionalGetCompany(professionalSelectedCardData.professional_id)
                                                            }}
                                                            disabled={recomBtnDisable === 5}
                                                        >
                                                            Recommend a Job
                                                        </button>
                                                    </div>

                                                    <div className="col-12 col-sm-4 mt-3 mt-sm-0">
                                                        {
                                                            professionalExpertNotes === "" ?
                                                                <button type={"button"}
                                                                    className={"btn w-100 btn-transparent border border-brand-color candidate-right-side-btn"}
                                                                    data-bs-toggle={"modal"}
                                                                    data-bs-target="#expertTakeNotesModal"
                                                                    onClick={() => {
                                                                        setprofessionalClearNotes(false)
                                                                        setprofessionalSendNotes(false)
                                                                    }} >
                                                                    Take Expert Notes
                                                                </button>
                                                                :
                                                                <button type={"button"}
                                                                    className={"btn btn-transparent border border-brand-color candidate-right-side-btn"}
                                                                    data-bs-toggle={"modal"}
                                                                    data-bs-target="#expertTakeNotesModal"
                                                                    onClick={() => {
                                                                        setprofessionalClearNotes(false)
                                                                        setprofessionalSendNotes(false)
                                                                    }} >
                                                                    Expert Notes
                                                                </button>
                                                        }
                                                    </div>
                                                    {
                                                        professionalSelectedCardData?.profile_percentage > 30 ?
                                                            <div className="col-12 col-sm-4 mt-3 mt-sm-0">
                                                                <button type={"button"}
                                                                    className={"btn w-100 btn-transparent border border-brand-color candidate-right-side-btn"}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#shareModal"
                                                                >
                                                                    <FaShare />
                                                                    <span className='ps-2'>Share</span>
                                                                </button>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mt-3">
                                    {
                                        initialGlow ?
                                            <h1 className='employer-card-candidate-name placeholder rounded-2 col-4 py-2 pb-3'></h1>
                                            :
                                            <h1 className='employer-card-candidate-name'>Recommended Jobs</h1>
                                    }
                                    <div className="row w-100">
                                        {
                                            initialGlow ?
                                                recommendedPlaceholderArray.map((v, i) => {
                                                    return <div className="col-12 col-md-6 col-xl-4 py-2" key={i}>
                                                        <div className="d-flex flex-wrap border rounded-2 w-100 p-3 pe-0">
                                                            <div className="col-3">
                                                                <img
                                                                    src={""}
                                                                    alt="..."
                                                                    width={50}
                                                                    height={50}
                                                                    className="pe-none placeholder rounded-circle"
                                                                />
                                                            </div>
                                                            <div className="col-9">
                                                                <div className="container-fluid">
                                                                    <p className='mb-0 pb-1 superAdmin-recommended-card-heading placeholder rounded-2 w-100 py-3 mb-1'></p>
                                                                    <p className="mb-0 superAdmin-recommended-card-sub-content mb-1">
                                                                        <span className="pe-2 placeholder rounded-2"><HiOutlineBriefcase /></span>
                                                                        <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                                                    </p>
                                                                    <p className="mb-0 superAdmin-recommended-card-sub-content">
                                                                        <span className="pe-2 placeholder rounded-2"><GrLocation /></span>
                                                                        <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                                :
                                                recommendedProfiles.length > 0 ?
                                                    recommendedProfiles.map((v, i) => {
                                                        return (
                                                            <RecommendedJobCard
                                                                heading={v.job_title}
                                                                contentOne={v.company_name}
                                                                contentTwo={v.city}
                                                                image={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${v.profile_image}`}
                                                                id={v.job_id}
                                                                key={i}
                                                                cardType={true}
                                                                handleDeleteRecommended={handleDeleteRecommended}
                                                                deletingCardId={deletingCardId}
                                                            />
                                                        )
                                                    })

                                                    :
                                                    <RecommendedJobCard cardType={false} icon="building" />
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 border-bottom border-secondary border-1 py-4">
                                {/* About card  */}
                                {
                                    professionalAbout !== "" ?
                                        <div className="card border-0 ">
                                            <div className="card-body ">
                                                <div className="d-flex justify-content-between ms-1">
                                                    <label className="profile-side-headers d-flex align-items-center">
                                                        <FaUserTie className="me-4 brand-color fs-4" />
                                                        <span>About</span>
                                                    </label>

                                                </div>
                                                <div className="ms-5 mt-3 profile-descriptions">
                                                    <p className={'text-break ms-1'}>{professionalAbout}</p>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        null
                                }


                                {/* experience card  */}
                                {
                                    experience.length > 0 ?
                                        <div className="card border-0">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between ms-1">
                                                    <label className="profile-side-headers d-flex align-items-center">
                                                        <PiBagFill className="me-4 brand-color fs-4" />
                                                        <span>Experience</span>
                                                    </label>
                                                </div>

                                                {
                                                    experience.map((val) => {
                                                        return (
                                                            <React.Fragment key={val.id}>

                                                                {
                                                                    <div className="ms-5">
                                                                        <div className="d-flex justify-content-between mt-3 ">
                                                                            <label className={window.location.pathname === "/employer_dashboard/candidates" ? " d-inline-block w-100 employer-card-Content-short-heading" : "profile-inner-headers  d-inline-block w-75"}>
                                                                                <span >{val.job_title} | {val.company_name}</span>
                                                                            </label>
                                                                        </div>



                                                                        <label className="profile-descriptions mt-2">
                                                                            <IoCalendarOutline />&nbsp; <span> {handleDateConvert(val.start_date)}</span> &nbsp;-&nbsp;<span> {handleDateConvert(val.end_date)}&nbsp; </span>
                                                                            <span className={window.location.pathname === "/employer_dashboard/candidates" ? "employer-card-Content" : "d-flex align-items-center gap-2"}>
                                                                                <IoLocationOutline /> {val.job_location}
                                                                            </span>
                                                                        </label>

                                                                        <p className={window.location.pathname === "/employer_dashboard/candidates" ? "mt-1 text-break employer-card-Content" : "mt-1 profile-descriptions text-break"}>
                                                                            {val.job_description}
                                                                        </p>
                                                                        <hr />
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        :
                                        null
                                }

                                {/* education card  */}
                                {
                                    education.length > 0 ?
                                        <div className="card border-0">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between ms-1">
                                                    <label className="profile-side-headers d-flex align-items-center">
                                                        <PiBagFill className="me-4 brand-color fs-4" />
                                                        <span>Education</span>
                                                    </label>
                                                </div>

                                                {
                                                    education.map((val) => {
                                                        return (
                                                            <React.Fragment key={val.id}>

                                                                {
                                                                    <div className="ms-5">
                                                                        <div className="d-flex justify-content-between mt-3 ">
                                                                            <label className={window.location.pathname === "/employer_dashboard/candidates" ? "placeholder-glow d-inline-block w-100 employer-card-Content-short-heading" : "profile-inner-headers placeholder-glow d-inline-block w-75"}>
                                                                                <span className="text-break">{val.degree_level} {val.specialisation} |  {val.institute_name} </span>
                                                                            </label>
                                                                        </div>



                                                                        <label className="profile-descriptions mt-2">
                                                                            <IoCalendarOutline />&nbsp; <span> {handleDateConvert(val.start_date)}</span> &nbsp;-&nbsp;<span> {handleDateConvert(val.end_date)}&nbsp; </span>
                                                                            <span className={window.location.pathname === "/employer_dashboard/candidates" ? "employer-card-Content" : "d-flex align-items-center gap-2"}>
                                                                                <IoLocationOutline /> {val.institute_location}
                                                                            </span>
                                                                        </label>
                                                                        <hr />
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        :
                                        null
                                }

                                {/* skills card  */}
                                {
                                    skills.length > 0 ?
                                        <div className="card border-0">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between ms-1">
                                                    <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                        <HiLightBulb className="me-4 brand-color fs-4" />
                                                        <span>Skills</span>
                                                    </label>

                                                </div>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                        {
                                                            skills.map((skill, index) => {
                                                                return (
                                                                    <React.Fragment key={skill.id}>
                                                                        <div className="col mt-0">
                                                                            <div className="employer-card-skills border rounded-2 p-2 fw-bold mb-4">
                                                                                {skill.skill_name} -{" "}
                                                                                <span className="fw-normal">
                                                                                    {skill.skill_level}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </React.Fragment>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        null
                                }

                                {/* preference card  */}
                                {
                                    professionalPreferences !== "" ?
                                        <div className="card border-0">
                                            <div className="card-body ">
                                                <div className="d-flex justify-content-between ms-1">
                                                    <label className="profile-side-headers d-flex align-items-center">
                                                        <FaUserTie className="me-4 brand-color fs-4" />
                                                        <span>Preference</span>
                                                    </label>

                                                </div>
                                                <div className="ms-5 mt-3 profile-descriptions">
                                                    <p className={'text-break ms-1'}>{professionalPreferences}</p>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        null
                                }

                                {/* video  && language*/}

                                <div className="row mt-2 g-3 ">
                                    {
                                        video !== "" ?
                                            <div className="col-12 col-md-6 mb-3 mb-sm-0">
                                                <div className="card border-0">
                                                    <div className="card-body">
                                                        <div className={`d-flex justify-content-between ms-1 ${video.includes('.mp4') ? "mb-2" : ""}`}>
                                                            <label className="profile-side-headers d-flex align-items-center">
                                                                <RiVideoFill className="me-4 brand-color fs-3" />
                                                                <span>
                                                                    Video
                                                                </span>
                                                            </label>
                                                        </div>

                                                        {
                                                            video.includes('.mp4') ?
                                                                <div className="d-flex justify-content-center mb-4">
                                                                    <VideoPlayer
                                                                        uploadedVideoFile={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${video}`}
                                                                        isVideoUploaded={true}
                                                                    />
                                                                </div>
                                                                :
                                                                null
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            null
                                    }

                                    {
                                        language.length > 0 ?
                                            <div className="col col-md-6">
                                                <div className="card border-0">
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between ms-1">
                                                            <label className="profile-side-headers d-flex align-items-center">
                                                                <IoLanguage className="me-4 brand-color fs-4" />
                                                                <span> Languages </span>
                                                            </label>
                                                        </div>
                                                        <div className="ms-5 mt-3 ">
                                                            {
                                                                language.map((language, index) => {
                                                                    return (
                                                                        <React.Fragment key={index}>
                                                                            <div className="d-flex justify-content-between" key={language.id}>
                                                                                <label className="profile-inner-headers">
                                                                                    {language.language_known}
                                                                                </label>
                                                                            </div>
                                                                            <p className="mt-1 profile-descriptions">
                                                                                {language.language_level}
                                                                            </p>
                                                                            <hr />
                                                                        </React.Fragment>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>




                                {/* additional info */}
                                {
                                    additionalInfo.length > 0 ?
                                        <div className="card border-0 mt-2">
                                            <div className="card-body ">
                                                <div className="d-flex justify-content-between ms-1">
                                                    <label className="profile-side-headers d-flex align-items-center">
                                                        <MdAddToPhotos className="me-4 brand-color fs-4" />
                                                        <span>
                                                            Additional Information
                                                        </span>
                                                    </label>
                                                </div>

                                                <div className="ms-5 mt-3">
                                                    {
                                                        additionalInfo.map((info, index) => {
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <div className="additional-information">
                                                                        <div className="d-flex justify-content-between ">
                                                                            <label className="profile-inner-headers ">
                                                                                {info.title}
                                                                            </label>
                                                                        </div>
                                                                        <ul className="mt-1 profile-descriptions">
                                                                            <li>
                                                                                <p className='text-break'>{info.description}</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        null
                                }

                            </div>

                            {/* pdf  */}
                            {
                                professionalPdf !== "" ?
                                    <div className="col-12 pt-5">
                                        <div className="container-fluid">
                                            <div className="row align-items-center">
                                                <div className="col-6">
                                                    <h1 className="employer-card-Content-heading">Resume</h1>
                                                </div>
                                                <div className="col-6 text-end">
                                                    <button type="button" className="btn btn-transparent border btn-brand-color candidate-right-side-btn">
                                                        <a href={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${professionalPdf}`} className="text-light text-decoration-none" download>Download</a>
                                                    </button>
                                                </div>
                                            </div>
                                            <Pdf pdfUrl={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${professionalPdf}`} />
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                        </div>
                    </div>
                    :
                    <div className="h-100 w-100 row align-items-center">
                        <p className='text-center'>No Data Found</p>
                    </div>
            )
            }

            {/* take notes modal box  */}
            <div
                className="modal fade"
                id="expertTakeNotesModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-md vh-50">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                Take Expert notes
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeExpertNotesApplyModal"
                            ></button>
                        </div>
                        <div className="modal-body border-bottom-0">
                            <div className="container">
                                <div className="row">
                                    <textarea
                                        className="p-3 rounded-3 form-control outline-none"
                                        minLength={25}
                                        maxLength={10000}
                                        rows={5}
                                        placeholder="Enter your text here"
                                        value={professionalkeepNotes}
                                        onChange={handleExpertNotes}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer rounded-top-2">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-6 ">
                                        {
                                            professionalClearNotes ?
                                                <button className="btn btn-brand-color pe-none w-100 my-2 px-3" type="button">
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="ps-2 d-none d-lg-inline">Clearing...</span>
                                                </button>
                                                :
                                                professionalSendNotes ?
                                                    <button
                                                        type="button"
                                                        className="btn btn-transparent border border-brand-color w-100 my-2 px-3 candidate-right-side-btn pe-none"
                                                    >
                                                        Clear
                                                    </button>
                                                    :
                                                    <button
                                                        type="button"
                                                        className="btn btn-transparent border border-brand-color w-100 my-2 px-3 candidate-right-side-btn"
                                                        onClick={() => handleProfessionalupdateNotes("clear")}
                                                    >
                                                        Clear
                                                    </button>
                                        }

                                    </div>
                                    <div className="col-lg-6 ">
                                        {
                                            professionalSendNotes ?
                                                <button className="btn btn-brand-color pe-none w-100 my-2 px-3" type="button">
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="ps-2 d-none d-lg-inline">Sending...</span>
                                                </button>
                                                :
                                                professionalClearNotes ?
                                                    <button
                                                        type="button"
                                                        className="btn btn-brand-color my-2 px-3 w-100 pe-none"
                                                    >
                                                        Send
                                                    </button>
                                                    :
                                                    <button
                                                        type="button"
                                                        className="btn btn-brand-color my-2 px-3 w-100"
                                                        onClick={() => handleProfessionalupdateNotes("send")}
                                                    >
                                                        Send
                                                    </button>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* make recommendation */}
            <div
                className="modal fade"
                id="professionalMakeRec"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg vh-50">
                    <div className="modal-content p-2">
                        <div className="modal-header border-bottom-0">
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                Make Recommendations
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeMakeRecBtn"
                                onClick={() => {
                                    setSelectedCompanyName([])
                                    setSelectedJobRole([])
                                    setRecomFeedback("")
                                }}
                            ></button>
                        </div>
                        <div className="modal-body border-bottom-0">
                            <div className="container">
                                <form className="row">

                                    {
                                        makeRecommendationLoading ?
                                            <>
                                                <div className="mb-3 col-12 col-md-6">
                                                    <p className='mb-0 placeholder w-50 py-3 rounded-2 mb-1'></p>
                                                    <div className='w-100 placeholder rounded-2 py-5'></div>
                                                </div>

                                                <div className="mb-3 col-12 col-md-6">
                                                    <p className='mb-0 placeholder w-50 py-3 rounded-2 mb-1'></p>
                                                    <div className='w-100 placeholder rounded-2 py-5'></div>
                                                </div>

                                                <div className="mb-3 col-12">
                                                    <p className='mb-0 placeholder w-75 py-3 rounded-2 mb-1'></p>
                                                    <div className='w-100 placeholder rounded-2 py-5'></div>
                                                </div>
                                            </>
                                            :

                                            recCompanyList.length > 0 ?
                                                <>

                                                    <div className="mb-3 col-12 col-md-6">
                                                        <p className='mb-0 pb-1'>Company Name</p>
                                                        <Select
                                                            color='#ffa32d'
                                                            style={{ fontSize: ".9rem" }}
                                                            className='rounded-1'
                                                            options={convertCompantList}
                                                            onChange={(values) => {
                                                                setSelectedCompanyName(values)
                                                                setSelectedJobRole([])
                                                            }}
                                                            values={selectedCompanyName}
                                                        />
                                                    </div>

                                                    <div className="mb-3 col-12 col-md-6">
                                                        <p className='mb-0 pb-1'>Job Role</p>
                                                        <Select
                                                            color='#ffa32d'
                                                            style={{ fontSize: ".9rem" }}
                                                            className='rounded-1'
                                                            options={convertRoleList}
                                                            onChange={(values) => setSelectedJobRole(values)}
                                                            values={selectedJobRole}
                                                        />
                                                    </div>

                                                    <div className="mb-3 col-12">
                                                        <p className='mb-0 pb-1'>Why do you think this job would be a good fit for this professional?</p>
                                                        <textarea
                                                            className="p-3 rounded-3 mb-3 form-control outline-none"
                                                            minLength={25}
                                                            maxLength={10000}
                                                            rows={8}
                                                            placeholder="Enter your text here"
                                                            value={recomFeedback}
                                                            onChange={handleSetRecommendationFeedback}
                                                        />
                                                    </div>
                                                </>
                                                :
                                                <div className='empty-makeRecommendation-height row align-items-center text-center'>
                                                    <p>The candidate has not applied for any jobs.</p>
                                                </div>
                                    }
                                </form>
                            </div>
                        </div>

                        <div className="modal-footer border-top-0">
                            <div className="container">
                                <div className="row float-end">
                                    <div className="col-lg-12 ">
                                        {
                                            makeRecommendationLoading ?
                                                <button
                                                    type="button"
                                                    className="btn col-6 my-2 px-5 placeholder pe-none">
                                                </button>
                                                :
                                                recCompanyList.length > 0 ?
                                                    professionalMakeRecommendation ?
                                                        <button className="btn btn-brand-color pe-none" type="button">
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            <span className="ps-2 d-none d-lg-inline">Recommending...</span>
                                                        </button>
                                                        :
                                                        <button
                                                            type="button"
                                                            className="btn btn-brand-color my-2 px-4"
                                                            onClick={handleMakeRecomBtn}>
                                                            Recommend
                                                        </button>

                                                    :

                                                    <button
                                                        type="button"
                                                        className="btn btn-brand-color my-2 px-4"
                                                        data-bs-dismiss="modal">
                                                        Close
                                                    </button>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* share modal  */}
            <div
                className="modal fade"
                id="shareModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Share
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body pt-0 ">
                            <div className="mb-3 position-relative">
                                <label htmlFor="message-text" className="col-form-label">
                                    Share with Employer
                                </label>
                                <input
                                    className="form-control  mx-auto mt-0 linkFieldSize"
                                    id="message-text"
                                    value={process.env.REACT_APP_SHARE_BASEURL + "/employer_dashboard/pool?prof_id=" + encryptData(professionalSelectedCardData?.professional_id)}
                                    readOnly
                                />
                                <button
                                    type="button"
                                    className="btn btn-brand-color button-position"
                                    onClick={() => handleCopytext(process.env.REACT_APP_SHARE_BASEURL + "/employer_dashboard/pool?prof_id=" + encryptData(professionalSelectedCardData?.professional_id))}
                                >
                                    Copy
                                </button>
                            </div>

                            <div className="mb-5 position-relative">
                                <label htmlFor="message-text" className="col-form-label">
                                    Share with Partner
                                </label>
                                <input
                                    className="form-control  mx-auto mt-0 linkFieldSize"
                                    id="message-text"
                                    value={process.env.REACT_APP_SHARE_BASEURL + "/partner_dashboard/pool?prof_id_partner=" + encryptData(professionalSelectedCardData?.professional_id)}
                                    readOnly
                                />
                                <button
                                    type="button"
                                    className="btn btn-brand-color button-position"
                                    onClick={() => handleCopytext(process.env.REACT_APP_SHARE_BASEURL + "/partner_dashboard/pool?prof_id_partner=" + encryptData(professionalSelectedCardData?.professional_id))}
                                >
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfessionalDetailedView